import { Injectable } from '@angular/core';
import { LoadChildrenCallback, Route, mapToCanActivate } from '@angular/router';
import { Config } from 'src/modules/app-template/models/config.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { AuthGuard } from '../misc/auth.guard';
import { AdminPageDefinition } from '../models/admin-page-definition.model';
import { FeatureModule } from '../models/feature.module';

@Injectable({providedIn: "root"})
export class FeatureModuleService {

    modules: FeatureModule[] = [];

    register(module: FeatureModule): void {
        let n = module.getId();
        if (Config.get().activeModules.includes(n) && this.modules.find(item => item.constructor.name === n) == null) {
            this.modules.push(module);
        }
    }

    async beforeAppStart(): Promise<void> {
        for (let module of this.modules) {
            await module.beforeAppStart();
        }
    }

    getAdminPages(): AdminPageDefinition[] {
        return Arrays.explode(this.modules, module => module.getAdminPages());
    }

    getModules(): FeatureModule[] {
        return this.modules;
    }

    //Der Parameter modulePath sollte auf das RoutingModule verweisen, nicht auf das Modul an sich
    //Im Falle, dass ein Modul ein anderen Modul mit Routen importiert werden sonst Routen vermischt
    createModuleRoute(path: string, modulePath: LoadChildrenCallback): Route {
        return {
            path,
            canActivate: mapToCanActivate([AuthGuard]),
            loadChildren: modulePath
        };
    }
}
